import Link from "next/link";
import { testimonialsData } from "@/data/testimonialsData";

interface CourseTestimonialsMiniProps {
  courseSlug?: string;
}

export default function CourseTestimonialsMini({ courseSlug = "" }: CourseTestimonialsMiniProps) {
  const byCourse = testimonialsData.filter((item) => item.courseSlug === courseSlug);

  const fallback = [...testimonialsData].sort((a, b) => {
    if (b.rating !== a.rating) {
      return b.rating - a.rating;
    }

    return a.id - b.id;
  });

  const selected = (byCourse.length > 0 ? byCourse : fallback).slice(0, 2);

  if (selected.length === 0) {
    return null;
  }

  return (
    <section className="bg-[#F8FAFF] border border-[#E6EEFF] rounded-2xl p-6 md:p-8">
      <div className="flex items-center justify-between gap-4 mb-6">
        <h2 className="text-[#1A1A1A] text-xl md:text-2xl font-bold">Student Reviews</h2>
        <Link
          prefetch={true}
          href="/testimonials"
          className="text-sm font-bold text-[#1B61FF] hover:text-blue-700"
        >
          See all reviews
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {selected.map((item) => (
          <article key={item.id} className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="flex items-center gap-1 text-[#FF9F43] mb-3">
              {Array.from({ length: item.rating }).map((_, i) => (
                <span key={`${item.id}-star-${i}`}>★</span>
              ))}
            </div>

            <p className="text-[#555555] text-[18px] leading-relaxed mb-4">&quot;{item.text}&quot;</p>

            <div className="pt-3 border-t border-gray-100">
              <p className="text-[#1A1A1A] text-[18px] font-bold">{item.author}</p>
              <p className="text-[#1B61FF] text-[16px] font-semibold mt-1">{item.role}</p>
              <p className="text-[#666666] text-[16px] mt-1">{item.location}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

